<template>
      <div id="userForm" class="form">
        <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
          <v-text-field
              v-model="user.firstName"
              label="First Name"
              :required="true"
            />
            <v-text-field
              v-model="user.lastName"
              label="Last Name"
              :required="true"
            />
            <v-text-field
              v-model="user.username"
              label="User Name"
              :required="true"
            />
            <v-text-field
              v-model="user.phone"
              label="Phone"
              :required="true"
            />
            <v-text-field
              v-model="user.email"
              label="Email"
              :required="true"
            />
            
        <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
        </v-form>
      </div>
    </template>
    
<script>
  import { getUser } from "@/services/user";
  
  
  import { mapActions } from "vuex";

  

  export default {
    props: ["id"],
    data () {
      return {
        loaded: false,
        valid: false,
        user: {
          relations: {
            
          },
          firstName: '',
lastName: '',
username: '',
phone: '',
email: '',

        }
      }
    },
    created() {
      this.setInstace();
    },
    methods: {
      ...mapActions("user", ["createUser", "updateUser"]),
      ...mapActions("messages", [
        "addMessage",
        "addErrorMessage",
        "addSuccessMessage"
      ]),
      
      async handleSubmit() {
        if (this.id) {
          let user = this.user;
          delete user.relations;

          this.updateUser(user)
          .then( (response) => {
            console.log(response);
            this.addSuccessMessage("User was updated successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error updating User, please try again later");
          });
        } else {
          let user = this.user;
          delete user.relations;

          this.createUser(user)
          .then( response => {
            console.log(response);
            this.addSuccessMessage("User was created successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error creating User, please try again later");
          })
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      setInstace() {
        if (this.id) {
          this.user.id = this.id;
          getUser(this.id)
            .then(response => {
              let instance = response.data;
              for (let property in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, property) && Object.prototype.hasOwnProperty.call(this.user, property)) {
                  this.user[property] = instance[property];
                }
              }
              this.loaded = true;
            })
        } else {
          this.loaded = true;
        }
        this.setDependencies();
      },
      setDependencies() {
        
      }
    },
    components: {
      
    }
  }
</script>
